// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9q-0";
export var optionCard = "_9q-1";